import qs from 'qs';

export default {
    baseURL:
        process.env.NODE_ENV === 'development'
            ? process.env.REACT_APP_PUBLIC_API_URL
            : window.REACT_APP_PUBLIC_API_URL,
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' }),
    timeout: 60 * 1000,
};
